import {useQuery} from "@tanstack/react-query";
import {ExportsApiClient} from "@/Service/Api/V1/ApiClients/ExportsApiClient";
import {QueryKeys} from "@/Service/Api/V1/QueryKeys/QueryKeys";

type useGetCasesExportParams = {
    from?: string;
    to?: string;
    enabled?: boolean;
}

export const useGetCasesExport = ({from, to, enabled}: useGetCasesExportParams) => useQuery({
    ...QueryKeys.exports.cases({from, to}),
    queryFn: async () => await ExportsApiClient.getCasesExport({
        from,
        to
    }),
    enabled: enabled
})